module.exports = "/build/web/svg/arrow-left.92cfdc8bdd857d209c13f52847b3a7be.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/arrow-left.svg
// module id = 143
// module chunks = 24